var _path, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1171274981(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4334 49.3245C43.0672 50.2976 34.3012 44.1291 32.6223 44.1156C30.9434 44.1021 22.0786 50.1287 20.7284 49.1338C19.3782 48.1388 22.5525 37.9193 22.0466 36.323C21.5408 34.7267 13.0533 28.182 13.585 26.5941C14.1168 25.0061 24.8447 24.8586 26.2108 23.8855C27.577 22.9125 31.1963 12.8411 32.8753 12.8545C34.5541 12.8681 38.0099 22.9964 39.3601 23.9914C40.7104 24.9862 51.4346 25.3064 51.9406 26.9027C52.4465 28.499 43.8544 34.9062 43.3226 36.4942C42.791 38.0822 45.7996 48.3514 44.4334 49.3245Z",
    fill: "url(#paint0_linear_664_293)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30.25,
    stroke: "url(#paint1_linear_664_293)",
    strokeWidth: 3.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_293",
    x1: 13.5611,
    y1: 31.1416,
    x2: 51.9621,
    y2: 31.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00357F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_664_293",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1171274981);
export default __webpack_public_path__ + "static/media/Group 1171274981.c57c8a9d69a93b80ca8bb5881e25beaa.svg";
export { ForwardRef as ReactComponent };